import { useState, useCallback, useEffect } from 'react';

let logoutTimer;


export const useAuth = () => {

    const [token, setToken] = useState(false);
    const [tokenExpirationDate, setTokenExpirationDate] = useState();
    const [userId, setUserId] = useState(false);
    const [type, setType] = useState(false);

    const login = useCallback((uid, token, expirationDate, type) => {
        setToken(token);
        setUserId(uid);
        setType(type);
        const tokenExpirationDate = 
          expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60); //1 hour
        setTokenExpirationDate(tokenExpirationDate);
        localStorage.setItem(
          'userData',
          JSON.stringify({ 
            userId: uid,
            token: token,
            expiration: tokenExpirationDate.toISOString(),
            type: type})
        );
    }, []);
    
    const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setUserId(null);
    setType(null);
    localStorage.removeItem('userData');
    }, []);

    useEffect(() => {
        
    if(token && tokenExpirationDate){
        const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
        logoutTimer = setTimeout(logout, remainingTime);
    }else{
        clearTimeout(logoutTimer);
    }
    }, [token, logout, tokenExpirationDate]);

    useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if(
        storedData &&
        storedData.token &&
        new Date(storedData.expiration) > new Date() ){
        login(storedData.userId, storedData.token, new Date(storedData.expiration), storedData.type);
    }
    }, [login]);

    return { token, login, logout, userId, type};
}